/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `person` - Person
 * * `legalentity` - Legal Entity
 */
export enum ContractorType {
  PERSON = 'person',
  LEGALENTITY = 'legalentity',
}
